import SendIcon from "@/assets/icons/send.svg"
import { CHAT_ROUTE } from "@/constants"
import { socket } from "@/modules/socket"
import type { Message } from "@/types"
import { type Dispatch, type RefObject, type SetStateAction, forwardRef, useImperativeHandle, useState } from "react"
import { v4 as uuidv4 } from "uuid"

interface Props {
  inputField: RefObject<HTMLInputElement | null>
  scrollToBottom: () => void
  refreshObserver: () => void
  setMessages: Dispatch<SetStateAction<Message[]>>
  sessionId: string | null
  comagicId: string | null
}

export interface InputFormRef {
  setSending: (value: boolean) => void
  sendMessage: (value: string) => void
}

export const InputForm = forwardRef<InputFormRef, Props>((props, ref) => {
  const { inputField, scrollToBottom, refreshObserver, setMessages, sessionId, comagicId } = props

  useImperativeHandle(ref, () => ({
    setSending,
    sendMessage,
  }))

  const [newMessage, setNewMessage] = useState("")
  const [sending, setSending] = useState(false)

  const sendMessage = async (msgArg?: string) => {
    const text = (msgArg ?? newMessage).trim()

    if (!text || sending) return

    setSending(true)
    setNewMessage("")

    const userMsg: Message = { id: uuidv4(), sender: "user", text, date: new Date().toISOString(), reaction: null }
    setMessages((prev) => [...prev, userMsg])

    scrollToBottom()
    refreshObserver()

    socket.emit(CHAT_ROUTE, {
      message: text,
      sessionId,
      comagicId,
    })
  }

  return (
    <div className="flex items-center !space-x-4">
      <input
        ref={inputField}
        type="text"
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        onKeyUp={(e) => e.key === "Enter" && sendMessage()}
        placeholder="Ваше сообщение..."
        className="flex-1 !border !border-[#434343] rounded-xl h-[46px] !px-4 !text-[16px] text-[#ffffff] placeholder:text-[#8c8c8c] transition:border-color duration-200"
      />
      <button
        onClick={() => sendMessage()}
        disabled={sending}
        className="relative w-12 h-12 flex justify-center items-center bg-gradient rounded-xl disabled:pointer-events-none ring-0 hover:opacity-80 transition-opacity"
      >
        <SendIcon className="w-5 h-5 fill-[#ffffff]" />
        {sending && (
          <span className="absolute left-0 top-0 right-0 bottom-0 rounded-[inherit] bg-[#3d3c3c80] flex justify-center items-center">
            <span className="w-8 h-8 rounded-full !animate-spin border-3 border-[#ffffff] border-t-transparent"></span>
          </span>
        )}
      </button>
    </div>
  )
})
